module.exports = __webpack_public_path__ + "img/icon (14).0e5dfbb3.png";